import { baseQuery } from '../baseQuery';
import { ServiceTypeAvailability } from 'types';

type PutTechnicianServiceTypePayload = {
  techId: number;
  technicianServiceTypeId: number;
  status: ServiceTypeAvailability;
};

export const putTechnicianServiceType = async (payload: PutTechnicianServiceTypePayload) => {
  const { techId, technicianServiceTypeId, ...rest } = payload;
  const { data } = await baseQuery(`technicians/${techId}/service-types/${technicianServiceTypeId}`, {
    type: 'PUT',
    body: {
      ...rest,
    },
  });

  return data;
};
